import { useMemo } from "react";
import { tableHooks } from "components/Table";
import { systems } from 'keys'
import { IconButtonGroup } from "components/Form";
import { CallMissedOutgoing, RemoveRedEyeOutlined, Replay } from "@mui/icons-material";
import { adminAssessmentsHooks } from "pages/Admin/TranscriptionSystem/AdminAssessments";
import { currentDateTime, decimalToTime, formatDateTime } from "utils/formatter";
import { audioCuttingHooks, markingWordsHooks } from "..";
import { ReactComponent as VisibilityIcon } from 'assets/icons/Visibility.svg';
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { ReactComponent as BackToIcon } from 'assets/icons/BackTo.svg';
import { SvgIcon, Tooltip, IconButton } from "@mui/material";


export const audioCuttingByCell = {
    accessorKey: 'audio_cutting_update_by_username',
    enableSorting: false,
    header: 'נחתך ע"י'
}

export const audioCuttingDate = {
    accessorKey: "audio_cutting_last_update_date",
    header: "חיתוך אחרון",
    enableSorting: false,
    cell: info => info.getValue() ? currentDateTime(info.getValue()) : ""
}

export const audioCuttingDurationCell = {
    accessorKey: 'audio_cutting_duration',
    header: "משך חיתוך",
    enableSorting: false,
    cell: info => decimalToTime(info.getValue()),
}

export const audioCuttingStartDateCell = {
    accessorKey: 'audio_cutting_start_date',
    header: " התחלת חיתוך",
    enableSorting: false,
    cell: info => info.getValue() ? `${formatDateTime(info.getValue()) || ""}` : "",
}


export const audioCuttingEndDateCell = {
    accessorKey: 'audio_cutting_end_date',
    header: "סיום חיתוך",
    enableSorting: false,
    cell: info => info.getValue() ? `${formatDateTime(info.getValue()) || ""}` : "",
}

export const useViewAssessmentCell = () => {
    const selectAndViewAssessment = adminAssessmentsHooks.useSelectAndCutting()

    return {
        accessorKey: 'view_audio_cutting',
        header: "צפייה",
        enableSorting: false,
        cell: ({ row }) => {

            return (
                <IconButtonGroup
                    color="thirdly4"
                    tooltip="לצפיה"
                    icon={VisibilityIcon}
                    selected={true}
                    action={() => {
                        selectAndViewAssessment(row.original)
                    }}
                />
            );
        }
    }
}

export const useGoAssessmentCell = () => {
    const selectAndViewAssessment = adminAssessmentsHooks.useSelectAndCutting()

    return {
        accessorKey: 'enter_audio_cutting',
        header: "כניסה",
        enableSorting: false,
        cell: ({ row }) => {

            return (
                <Tooltip key={row.id} tooltip="לכניסה" placement="left">
                    <IconButton
                        className="transparent-icon"
                        onClick={() => {
                            selectAndViewAssessment(row.original)
                        }}
                    >
                        <SvgIcon component={GoIcon} inheritViewBox />
                    </IconButton>
                </Tooltip>
            );
        }
    }
}

export const useBackToCuttingCell = () => {
    const { action, loading } = audioCuttingHooks.useBackToConfirmation()

    return {
        accessorKey: 'back_to_cutting',
        header: "החזר לחיתוך",
        enableSorting: false,
        cell: ({ row }) => {

            const disabled = loading
            return (
                <IconButtonGroup
                    color="thirdly4"
                    tooltip="החזר לחיתוך"
                    icon={BackToIcon}
                    selected={!disabled}
                    disabled={disabled}
                    action={() => action(row.original, true)}
                />
            )
        }
    }
}